import React, { FC, useState } from 'react';
import Box from '@mui/material/Box';
import styled from '@mui/system/styled';
import ModalUnstyled from '@mui/base/ModalUnstyled';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { CircularProgress, Typography } from '@mui/material';
import { CloseIcon } from '../icons';
import theme from '@/mui/theme';
import ProductDetailModalContent from '@/components/fasce/ProductDetailModalContent';
import { getProductByPartNumber } from '@/data/hcl/sdk';

const StyledModal = styled(ModalUnstyled)({
  position: 'absolute',
  top: '0',
  maxWidth: '100%',
  bottom: 'unset',
  zIndex: '1300',
  right: '0',
  left: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&.MuiModal-hidden': {
    display: 'none',
  }
});

const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.5;
  -webkit-tap-highlight-color: transparent;
`;

const StyledBox = styled(Box)({
  [theme.breakpoints.up('sm')]: {
    padding: '49px 65px 76px',
    margin: '88px 100px 102px',
  },
  position: 'relative',
  backgroundColor: '#ffffff',
  border: '1px solid #979797',
  padding: '55px 16px 26px',
  margin: '0',
  maxWidth: '100%',
});

const StyledCloseIcon = styled(CloseIcon)({
  [theme.breakpoints.up('sm')]: {
    right: '0',
    width: '12px',
    height: '12px',
  },
  position: 'absolute',
  top: '2px',
  right: '12px',
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  padding: '20px',
  boxSizing: 'content-box',
});

interface ProductDetailModalProps {
  sku: string;
  openModalLabel: string;
  storeId: string;
  langId: string;
  breadcrumbs: any;
  attachments: any;
  garanzia: any;
  appUso: string;
  defaultImage : string;
  defaultThumb : string;
  parentProductName : string;
};

const ProductDetailModal: FC<ProductDetailModalProps> = ({ sku, openModalLabel, storeId, langId, breadcrumbs, attachments, garanzia, appUso, defaultImage, defaultThumb, parentProductName}) => {
  const [openModal, setOpenModal] = useState(false);
  const [productData, setProductData] = useState<Object | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Object | null>(null);

  const fetchModalData = async () => {
    setLoading(true);
    setError(null);

    if (sku === 'EXAMPLE-VERSIONI' || sku === 'EXAMPLE-ACCESSORI') {
      // Ad uso delle pagine di documentazione: https://disano-uat.vercel.app/it/doc/fasce/product-detail-table/
      // Simulo la chiamata al graphql hcl.
      setTimeout(() => {
        // TODO: creare un file di mock (\mocks\wcs\graphql\modalProduct.js)
        //       con un esempio di response per valorizzare productData
        setProductData({ sku: sku, example: 'example' });
        setLoading(false);
        setError(null);
      }, 4000);

    } else {

      // TODO: fare query graphql per reperire info prodotto
      //  const { productData, loading, error } = await getProductDetails(sku);
      let productData = await getProductByPartNumber(storeId,langId,sku);
      productData.data = Object.assign({}, productData.data, {selected:false});
      productData.data.name = parentProductName;
      // TODO: Aggiornare lo stato con le info prodotto
      setProductData(productData);
      setLoading(false);
      setError(null);
    }
  }

  const handleOpen = () => {
    document.querySelector('main')!.classList.add('modal-open');
    setOpenModal(true);
    if (!productData && !loading) {
      fetchModalData();
    }
  }

  const handleClose = () => {
    document.querySelector('main')!.classList.remove('modal-open');
    setOpenModal(false);
  }

  return (<>
    <Button onClick={handleOpen}>{openModalLabel}</Button>
    {openModal &&
      <StyledModal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={openModal}
        onClose={handleClose}
        components={{
          Backdrop: Backdrop
        }}
        disableScrollLock={true}
      >
        <StyledBox>
          <StyledCloseIcon onClick={handleClose} />
          <Container>

            {!productData && !error && <>
              <Box sx={{width: { xs: '280px', sm: '450px'}, textAlign: 'center', padding: '60px 0'}}>
                <CircularProgress />
              </Box>
            </>}

            {error && <>
              <Typography component="h3" sx={{marginTop: '20px', textAlign: 'center'}}>Sorry, an error occurred.<br/> Please try again later.</Typography>
            </>}

            {productData &&
              <ProductDetailModalContent productData={productData} breadcrumbs={breadcrumbs} attachments={attachments} garanzia={garanzia} appUso={appUso} defaultImage={defaultImage} defaultThumb={defaultThumb}/>
            }

          </Container>
        </StyledBox>
      </StyledModal>
    }
  </>)
}

export default ProductDetailModal;

